import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function EditDesignationModal({ show, handleClose, data }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">Edit Designation</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Designation Name</Form.Label>
            <Form.Control defaultValue={data?.name} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Department Name</Form.Label>
            <Form.Control defaultValue={data?.dept} />
          </Form.Group>

          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select defaultValue={data?.status}>
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange">
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}